<template lang="pug">
  div
    .flex-container.space-between.align-center.filters-row
      .flex-container.align-center
        ods-input-search(
          v-if="types.text"
          size='hecto'
          outlined
          :placeholder="$t('loyalty.search')"
          @input='inputSearch')
        ods-actions-menu.advanced-search(
          v-if="types.date"
          text="BÚSQUEDA AVANZADA"
          customClass="advanced-search-card"
          color="#888A91"
          size="10"
          popoverPosition="bottom-start")
          .flex-container.space-between.align-center.ods-mb-4
            span Fecha de Solicitud
            ods-button(type="text" v-if="clearButtonVisibility" @click="clearDateSearch").clear-date.ods-p-0 Limpiar
          ods-date-picker(
            v-model='dateSearch'
            type='daterange'
            :only-one-calendar="true"
            :calendar-always-visible="false"
            placeholder='Selecciona día'
            :clearable="false")
          ods-button(size="small" @click="dateSearchButton").ods-ml-4 Aplicar
      .flex-container.align-center
        span.tp-r-nano {{ rowSelectedTitle }}
        ods-divider(v-if="rowSelectedCount && types.actions" direction='vertical')
        ods-actions-menu(
          v-if="types.actions"
          customClass="card-menu"
          icon="overflow-menu"
          color="#888A91"
          size="18"
          popoverPosition="bottom-end")
          ul.menu
            li.menu__item
              a(href="#" @click.prevent="showExport = true")
                ods-icon(name="file_export" color="#B6B6B6" size="24" style="vertical-align: middle").ods-mr-2
                | Exportar
            li.menu__item
              a(href="#" @click.prevent="")
                ods-icon(name="print" color="#B6B6B6" size="24" style="vertical-align: middle").ods-mr-2
                | Imprimir
</template>

<script>
export default {
  name: 'FilterTable',

  props: {
    layout: {
      default: 'text, date, actions'
    },
    rowSelectedCount: {
      type: Number
    }
  },

  data () {
    return {
      dateSearch: null,
      types: {
        text: true,
        date: true,
        actions: true
      }
    }
  },

  watch: {
    layout: {
      immediate: true,
      handler (val) {
        const components = val.split(',').map((item) => item.trim())
        Object.keys(this.types).forEach((el) => {
          this.types[el] = (components.indexOf(el) > -1)
        })
      }
    }
  },

  computed: {
    rowSelectedTitle () {
      const msg = this.rowSelectedCount === 0 ? '' : this.rowSelectedCount > 1 ? 'ELEMENTOS SELECCIONADOS' : 'ELEMENTO SELECCIONADO'
      return this.rowSelectedCount > 0 ? `${this.rowSelectedCount} ${msg}` : ''
    },
    clearButtonVisibility () {
      return this.dateSearch
    }
  },

  methods: {
    inputSearch (val) {
      this.$emit('inputSearchFilter', val)
    },

    dateSearchButton () {
      const data = {
        fecdesde: {
          valueDate: this.$options.filters.formatDate(this.dateSearch[0])
        },
        fechasta: {
          valueDate: this.$options.filters.formatDate(this.dateSearch[1])
        }
      }
      this.$emit('paramsDateFilter', data)
    },

    clearDateSearch () {
      this.dateSearch = null
      this.$emit('resetDateFilter')
    }
  }
}
</script>
<style lang="scss" scoped>
.advanced-search {
  /deep/ .ods-actions-menu__button {
    &--text {
      color: $--color-primary;
      font-size: 10px;
      font-weight: 500;
      &.ods-actions-menu__button--active {
        background: unset;
      }
      &:hover {
        background: unset;
      }
    }
  }
}
</style>
